import { render, staticRenderFns } from "./AddMajor.vue?vue&type=template&id=657cce40&scoped=true"
import script from "./AddMajor.vue?vue&type=script&lang=js"
export * from "./AddMajor.vue?vue&type=script&lang=js"
import style0 from "./AddMajor.vue?vue&type=style&index=0&id=657cce40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657cce40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('657cce40')) {
      api.createRecord('657cce40', component.options)
    } else {
      api.reload('657cce40', component.options)
    }
    module.hot.accept("./AddMajor.vue?vue&type=template&id=657cce40&scoped=true", function () {
      api.rerender('657cce40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/DemandForm/AddMajor.vue"
export default component.exports